<app-navbar></app-navbar>
<main>
    <main>
        <section class="header relative pt-16 items-center flex mt-36 mb-10 ">
            <div class="container mx-auto lg:px-4 px-8">
                <div class="items-center flex flex-wrap justify-center">
                    <h3 class="font-semibold tracking-wide text-2xl lg:text-3xl text-center info-color">
                        Banan Privacy Policy </h3>
                </div>
                <!-- <p class="text-xl lg:text-2xl mt-4 info-color text-center leading-10">
                    Please read our terms and conditions carefully before using our services.
                </p> -->
                <div class="mx-auto max-w-7xl">
                    <div class="mx-auto max-w-4xl">
                        <article class="space-y-6 mt-10 text-gray-600 text-base leading-7">
                            <section>
                                <p class="text-lg text-justify mt-2 text-gray-800 ">
                                    This Banan Privacy Policy ( the “Privacy Policy”) must be read in conjunction with
                                    the  <a href="/terms-&-conditions"
                                    class="primary-color underline hover:text-blue-700">    Terms and Conditions.</a>
                                 Unless otherwise stated, all other capitalized terms
                                    contained in this Privacy Policy shall have the meaning given to it in the Terms. In
                                    the Privacy Policy, “we”, “us” or “our” refers collectively to Banan.
                                </p>
                            </section>
                            <section>

                                <p class="text-lg text-justify mt-2">
                                    <span class="font-bold text-gray-700">1. </span>The purpose of this Privacy Policy
                                    is to inform you of how we collect, use, disclose and process data and personal data
                                    relating to you, or that ma relate to a third party individual and is provided by
                                    you (collectively, “Data”). Please read this Privacy Policy carefully.
                                </p>


                            </section>

                            <section>
                                <h2 class="underline font-semibold tracking-wide text-lg secondary-color">Types of Data
                                    that we collect</h2>
                                <p class="text-lg text-justify mt-2">
                                    <span class="font-bold text-gray-700">2. </span> We may request certain types from
                                    you in connection with your Use of Banan and Banan Materials. Examples of the types
                                    of Data which we may request and collect include, but are not limited to:
                                </p>

                                <p class="text-lg text-justify mt-2">
                                    <span class="font-bold text-gray-700"> 2.1</span> Information relating to your
                                    Account;
                                </p>

                                <p class="text-lg text-justify mt-2">
                                    <span class="font-bold text-gray-700"> 2.2</span> Information about you from data
                                    source(s) approved by us;
                                </p>
                                <p class="text-lg text-justify mt-2">
                                    <span class="font-bold text-gray-700"> 2.3</span> our contact information, including
                                    your telephone number, email and mailing addresses;
                                </p>
                                <p class="text-lg text-justify mt-2">
                                    <span class="font-bold text-gray-700"> 2.4</span> Information from your Device
                                    including but not limited to your location information, IP address, MAC address,
                                    network interfaces, device type and model, and other forms of data from your Device
                                    in connection with the Use of Banan or Banan Materials;
                                </p>
                                <p class="text-lg text-justify mt-2">
                                    <span class="font-bold text-gray-700"> 2.5</span> Information relating to the
                                    version of the Banan app on your Device or your Use of Banan or Banan Materials,
                                    including but not limited to information relating to the usage of the various
                                    functionalities, features or clicks on the Banan Materials as well as Device
                                    permissions such as the permission to push notifications, use location services, use
                                    any connectivity services, and other similar information;
                                </p>

                                <p class="text-lg text-justify mt-2">
                                    <span class="font-bold text-gray-700"> 2.6</span> Fingerprint, Face Identification
                                    enrolled by, where applicable, the relevant Fingerprint Recognition Feature or Face
                                    Recognition Feature on your Registered Mobile Device;
                                </p>
                                <p class="text-lg text-justify mt-2">
                                    <span class="font-bold text-gray-700"> 2.7</span> Your Captured Face Data;
                                </p>

                                <p class="text-lg text-justify mt-2">
                                    <span class="font-bold text-gray-700"> 2.8</span> Your Login Credentials for Using
                                    Banan and Banan Materials; and
                                </p>
                                <p class="text-lg text-justify mt-2">
                                    <span class="font-bold text-gray-700"> 2.9</span> Such other information as may be
                                    provided by, or collected from you in connection with your Use of Banan and Banan
                                    Materials.
                                </p>
                            </section>

                            <section>

                                <p class="text-lg text-justify mt-2">
                                    <span class="font-bold text-gray-700">3. </span>
                                    We may collect the Data and other types of information relating to your activities
                                    in respect of Banan and Banan Materials through various technologies including but
                                    not limited to:
                                </p>

                                <p class="text-lg text-justify mt-2">
                                    <span class="font-semibold text-gray-700"> 3.1 Analytics Tags: </span> Analytics
                                    Tags are used by us to analyze the effectiveness of the functionalities and features
                                    of Banan and Banan Materials in order to improve general user experience. We may use
                                    information collected through such analytics tags in combination with your Data
                                    (such as transaction history and demographic information) to understand more about
                                    the profile of our users.
                                </p>
                                <p class="text-lg text-justify mt-2">
                                    <span class="font-semibold text-gray-700"> 3.2 Cookies: </span>
                                    Cookies are small data files which are sent to your browser or Device to store and
                                    track information about you when you use Banan and Banan Materials. Cookies are also
                                    used to improve and maintain the functionality of Banan and Banan Materials, and to
                                    track information such as the number of users of Banan and other similar information
                                    relating to the Use Banan and Banan Materials. While these cookies can tell us when
                                    you use Banan and Banan Materials, they cannot read data off your hard disk. Not all
                                    cookies collect personal data and you may configure your preferences and settings to
                                    reject the use of cookies.

                                </p>
                                <p class="text-lg text-justify mt-2">
                                    <span class="font-semibold text-gray-700"> 3.3 Server Logs: </span>
                                    Server logs are files and records of activity created by the Device that you Use
                                    Banan or Banan Materials form. For example, a web server log may record a history of
                                    page requests whereas other logs may record errors, access attempts or other
                                    information about your Device, such as your IP address of your Device’s cookie
                                    settings. We collect and retain such server logs for administrative, security and
                                    troubleshooting purposes.
                                </p>

                                <p class="text-lg text-justify mt-2">
                                    <span class="font-semibold text-gray-700"> 3.4 Device Information: </span>
                                    Information relating to your Device such as its model, type, operating system and
                                    other technical attributes.
                                </p>
                            </section>
                            <section>
                                <h2 class="underline font-semibold tracking-wide text-lg secondary-color">Why we collect
                                    Data</h2>
                                <p class="text-lg text-justify mt-2">
                                    <span class="font-bold text-gray-700">4. </span> Data requested and collected from
                                    you may be used, disclosed and processed by us for any, some or all of the following
                                    purposes:
                                </p>

                                <p class="text-lg text-justify mt-2">
                                    <span class="font-bold text-gray-700"> 4.1</span> To assist, process and facilitate
                                    your Use of Banan and Banan Materials, including registering and creating your
                                    Account, facilitating your login into your Account and your use of any features or
                                    functionalities of Banan and Banan Materials.
                                </p>

                                <p class="text-lg text-justify mt-2">
                                    <span class="font-bold text-gray-700"> 4.2</span>
                                    To carry out your instructions or respond to any queries, feedback or complaints
                                    provided by (or purported to be provided by) you or on your behalf, or otherwise for
                                    the purposes of responding to or dealing with your interactions with us;
                                </p>
                                <p class="text-lg text-justify mt-2">
                                    <span class="font-bold text-gray-700"> 4.3</span> To monitor and track your usage of
                                    Banan and Banan Materials, in order to assist us in understanding user behavior,
                                    trends and prefrences, and in improving Banan and Banan Materials. For the avoidance
                                    of doubt, we may also collect, use, disclose and process such Data to create reports
                                    and produce statistics regarding the above for record-keeping and reporting or
                                    publication purposes (whether internally or externally). Data used in such reports
                                    and statistics will be anonymized before publication;
                                </p>
                                <p class="text-lg text-justify mt-2">
                                    <span class="font-bold text-gray-700"> 4.4 </span>For the purposes of storing or
                                    creating backups of your Data for contingency or business continuity purposes;
                                </p>
                                <p class="text-lg text-justify mt-2">
                                    <span class="font-bold text-gray-700"> 4.5</span> To prevent or investigate any
                                    fraud, unlawful activity or omission or misconduct via the use of your Account,
                                    whether or not there is any suspicion of the aforementioned;

                                </p>

                                <p class="text-lg text-justify mt-2">
                                    <span class="font-bold text-gray-700"> 4.6</span>
                                    To deal with conflict of interests or investigate complaints in relation to your
                                    Account;
                                </p>
                                <p class="text-lg text-justify mt-2">
                                    <span class="font-bold text-gray-700"> 4.7</span> To authenticate your identity
                                    through the use of Banan;
                                </p>

                                <p class="text-lg text-justify mt-2">
                                    <span class="font-bold text-gray-700"> 4.8</span> To pre-fill any e-form, user
                                    registration page or screen on any approved recipient’s channel(s) with your Data;
                                </p>
                                <p class="text-lg text-justify mt-2">
                                    <span class="font-bold text-gray-700"> 4.9</span>
                                    To enable us to contact you or communicate with you on any matters relating to your
                                    Use of Banan, including but not limited to the purposes set out above, via email,
                                    push notifications or such other forms of communication that we may introduce from
                                    time to time depending on the functionality of Banan and your Device; and
                                </p>
                                <p class="text-lg text-justify mt-2">
                                    <span class="font-bold text-gray-700"> 4.10</span>
                                    For any other purpose(s) that do not appear above where permissible under any
                                    written law, as may be notified by us to you from time to time.
                                </p>
                            </section>

                            <section>

                                <p class="text-lg text-justify mt-2">
                                    <span class="font-bold text-gray-700">5. </span> If you provide us with Data:
                                </p>

                                <p class="text-lg text-justify mt-2">
                                    <span class="font-bold text-gray-700"> 5.1</span> we may share, transfer and
                                    disclose Data with Approved Service Providers and relevant third party service
                                    providers in connection with your Use of Banan and Banan Materials, unless such
                                    sharing is prohibited by written law; and
                                </p>

                                <p class="text-lg text-justify mt-2">
                                    <span class="font-bold text-gray-700"> 5.2</span>
                                    for your convenience, we may also display to you Data you had previously supplied
                                    us. This will speed up the transaction(s) and save you the trouble of repeating
                                    previous submissions. Should such displayed Data be out-of-date, you shall be
                                    required to supply the latest Data through the relevant functionality in Banan
                                    without delay.
                                </p>

                            </section>

                            <section>
                                <h2 class="underline font-semibold tracking-wide text-lg secondary-color">Data of third
                                    party individuals</h2>
                                <p class="text-lg text-justify mt-2">
                                    <span class="font-bold text-gray-700">6. </span> In the course of your Use of Banan
                                    or Banan Materials, we may collect Data relating to other individuals from you.
                                </p>

                                <p class="text-lg text-justify mt-2">
                                    <span class="font-bold text-gray-700"> 6.1 </span> You shall, prior to disclosing to
                                    us such Data relating to other individuals:
                                </p>

                                <ul class=" list-inside ml-6 text-lg text-justify mt-2">
                                    <li>
                                        <span class="font-bold">a)</span> notify these individuals:
                                        <ul class=" list-inside ml-6 mt-2">
                                            <li>(i) that you will be providing their personal data to us;</li>
                                            <li>(ii) of the Purposes for which we will be collecting, using, disclosing,
                                                and processing their personal data, as set out in this Privacy Policy
                                                and as notified by us to you from time to time;</li>
                                        </ul>
                                    </li>
                                    <li>
                                        <span class="font-bold">b)</span> obtain the consent from the individuals whose
                                        personal data are being disclosed, permitting:
                                        <ul class=" list-inside ml-6 mt-2">
                                            <li>(i) you to disclose the personal data to us;</li>
                                            <li>(ii) us to collect, use, disclose and process these individuals'
                                                personal data, for the Purposes.</li>
                                        </ul>
                                    </li>
                                </ul>
                                <p class="text-lg text-justify mt-2">
                                    <span class="font-bold text-gray-700"> 6.2 </span>
                                    You represent and warrant that:
                                </p>

                                <ul class=" list-inside ml-6 text-lg text-justify mt-2">
                                    <li>
                                        <span class="font-bold">a)</span> the personal data that you will be providing
                                        us or have provided us is, complete, accurate, true and correct; and

                                    </li>
                                    <li>
                                        <span class="font-bold">b)</span> you have the valid authority and consent from
                                        these individuals to act on their behalf and provide their personal data to us
                                        to collect, use, disclose and process for the Purposes.
                                    </li>
                                </ul>

                            </section>

                            <section>
                                <h2 class="underline font-semibold tracking-wide text-lg secondary-color">How we handle and manage your Data</h2>
                                <p class="text-lg text-justify mt-2">
                                    <span class="font-bold text-gray-700">7. </span> Your Data may be stored in servers, systems or devices owned, operated or managed by us, a relevant Third Party or any third party service provider engaged by us or a relevant Third Party, or on your Device, and may be used by us (or our third party service providers) and Approved Service Providers to facilitate your Use of Banan or Banan Materials.
                                </p>

                            </section>
                            <section>
                                <p class="text-lg text-justify mt-2">
                                    <span class="font-bold text-gray-700">8. </span> 
                                    You may withdraw your consent to the use and disclosure of Data by us with reasonable notice; however, doing so may prevent proper Use of Banan or Banan Materials, or any part thereof and may also result in the cessation of your Use of Banan or Banan Materials, or any part thereof. We may retain, use, disclose and process your Data for any of the Purposes set out herein where permitted under any applicable law.
                            </section>

                            <section>
                                <h2 class="underline font-semibold tracking-wide text-lg secondary-color"> Changes to Privacy Policy</h2>
                                <p class="text-lg text-justify mt-2">
                                    <span class="font-bold text-gray-700">9. </span> 
                                    We reserve the right to change, modify or supplement the Privacy Policy at our discretion and at any time, by posting the changed, modified or supplemented Privacy Policy on or through the Banan Website, Banan app, or through such other means as we may deem appropriate. Your continued Use of Banan and Banan Materials following the posting of any change, modification or supplement will constitute your acceptance of such change, modification or supplement. If you do not agree to any change, modification or supplement to the Privacy Policy, please do not Use Banan or Banan Materials.                                </p>

                            </section>


                        </article>

                        <div class="items-center flex flex-wrap justify-center mt-3">
                            <h3 class="font-medium tracking-wide text-base text-center info-color">
                                This version of the Privacy Policy is dated 10 October 2022 </h3>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>

</main>
<app-footer></app-footer>